var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8955 3.29085C10.8955 4.68204 9.76823 5.80954 8.37809 5.80954C6.98794 5.80954 5.86072 4.68204 5.86072 3.29085C5.86072 1.89965 6.98794 0.772156 8.37809 0.772156C9.76823 0.772156 10.8955 1.89965 10.8955 3.29085Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71692 11.5624C2.71692 9.29742 4.04001 7.24927 6.08687 6.31228C7.41824 7.38785 9.32644 7.3878 10.6578 6.31212C12.7104 7.24916 14.0379 9.30171 14.0379 11.5721V14.906C10.4144 16.3921 6.3477 16.394 2.71849 14.9045L2.71692 14.9038V11.5624Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutline);
export default __webpack_public_path__ + "static/media/person-outline.75d4493f3e3a52f3ad3ddc8f2c118683.svg";
export { ForwardRef as ReactComponent };